/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PostLogDto, SignatureDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Log<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 타임딜 클릭 log 생성
   *
   * @tags log
   * @name CreateTimeDealLinkClickLog
   * @summary 타임딜 클릭 log 생성
   * @request POST:/v2/logs/click-log/time-deal
   * @secure
   */
  createTimeDealLinkClickLog = (data: SignatureDto, params: RequestParams = {}) =>
    this.http.request<PostLogDto, any>({
      path: `/v2/logs/click-log/time-deal`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description 이벤트 클릭 log 생성
   *
   * @tags log
   * @name CreateEventLinkClickLog
   * @summary 이벤트 클릭 log 생성
   * @request POST:/v2/logs/click-log/event
   * @secure
   */
  createEventLinkClickLog = (data: SignatureDto, params: RequestParams = {}) =>
    this.http.request<PostLogDto, any>({
      path: `/v2/logs/click-log/event`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
